import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Log environment variables for debugging
console.log('Environment:', process.env.NODE_ENV);
console.log('API Base URL:', process.env.REACT_APP_API_BASE_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);